"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adminReferralContract = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const utils_1 = require("../utils");
const c = (0, core_1.initContract)();
exports.adminReferralContract = c.router({
    getPlayerInvites: {
        method: 'GET',
        path: '/player/:playerId/invites',
        pathParams: zod_1.z.object({
            playerId: zod_1.z.string(),
        }),
        responses: {
            200: zod_1.z.array(zod_1.z.object({
                first_name: zod_1.z.string(),
                last_name: zod_1.z.string(),
                created_at: zod_1.z.coerce.date(),
                invitee_id: zod_1.z.string(),
                inviter_id: zod_1.z.string(),
                referral_id: zod_1.z.string(),
                inviter_bonus_status: zod_1.z.string(),
                invitee_bonus_status: zod_1.z.string(),
                bonus_scheme: zod_1.z.string(),
            })),
            400: c.type(),
        },
    },
    getPlayerReferrals: {
        method: 'GET',
        path: '/player/:playerId/referrals',
        pathParams: zod_1.z.object({
            playerId: zod_1.z.string(),
        }),
        responses: {
            200: zod_1.z.array(zod_1.z.object({
                first_name: zod_1.z.string(),
                last_name: zod_1.z.string(),
                created_at: zod_1.z.coerce.date(),
                invitee_id: zod_1.z.string(),
                inviter_id: zod_1.z.string(),
                referral_id: zod_1.z.string(),
                inviter_bonus_status: zod_1.z.string(),
                invitee_bonus_status: zod_1.z.string(),
                bonus_scheme: zod_1.z.string(),
            })),
            400: c.type(),
        },
    },
    hasActiveReferralForPlayer: {
        method: 'GET',
        path: '/player/:playerId/referrals/active',
        pathParams: zod_1.z.object({
            playerId: zod_1.z.string(),
        }),
        responses: {
            200: zod_1.z.object({
                hasActiveReferral: zod_1.z.boolean(),
            }),
            400: c.type(),
        },
    },
    applyReferralCodeForPlayer: {
        method: 'POST',
        path: '/player/:playerId/referrals/apply',
        pathParams: zod_1.z.object({
            playerId: zod_1.z.string(),
        }),
        body: zod_1.z.object({
            referralCode: zod_1.z.string(),
        }),
        responses: {
            200: utils_1.successSchema,
            400: c.type(),
        },
    },
}, {
    pathPrefix: '/admin',
    commonResponses: {
        401: c.type(),
    },
});
//# sourceMappingURL=referral.admin.contract.js.map